import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { EstruturaRetornoDadosOutputDto } from '../domain/DTOs/output/estrutura-retorno-dados.output.dto';
import { DadosContatosOutputDto } from '../domain/DTOs/output/dados-contatos-output-dto';

@Injectable()
export class DadosContatosService {

  constructor(private baseService: BaseService) {}

  public ObterDadosContatos(
  ): Observable<EstruturaRetornoDadosOutputDto<DadosContatosOutputDto>> {
    return this.baseService.get('DadosContatos/ObterDadosContatos');
  }
}
